// removed by extract-text-webpack-plugin
module.exports = {"CustomIcon":"Archive__CustomIcon__q5rIe"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Archive.css
// module id = 1692
// module chunks = 2